
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getBankInfo, setBank, addBank } from '@/api/merchant/bank'
import { bankAccountRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { operationMessage } from '@/utils/message'
import { getConstant, getEnterprise } from '@/api/universal'
import { LOADIPHLPAPI } from 'dns'

@Component({
  name: 'editAgentProduct',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) bankAccountId!: string

  private infoForm: any = {
    currency: '',
    bank_code: null,
    account_name: '',
    account_no: '',
    status: null,
    google_code: '',
    description: null,
    name: '',
    coin_type: null,
    address: ''
  }
  private rules = bankAccountRules

  private onCreate: any = {}
  private otherCurrency: any = []

  private agentProductInfo: any = {}
  private currencyTypes: any[] = this.$store.state.app.enterprise
    .available_currency
  private currentProductIndex: any = null
  private bankCodes: any = {}
  private coinType: any = {}
  private getBankCode: any = {}
  private getCoinType: any = {}
  private labelChange: any = '1'
  private loading = false
  private currencyChange: any = {}
  private configDataArr: any = []
  private availableCurrency: any = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.$emit('close')
  }

  private save () {
    ;(this.$refs.bankForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            merchant_no: this.merchant_no,
            ...this.infoForm
          }
          delObjEmptyKey(data)
          if (!this.bankAccountId) {
            await addBank(data).then((res: any) => {
              operationMessage(true)
              this.loading = false
              this.flagStr()
              this.back()
            })
          } else {
            await setBank(data).then((res: any) => {
              operationMessage(true)
              this.loading = false
              this.flagStr()
              this.back()
            })
          }
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }
  // 当选择货币发生改变
  private changeCurrency () {
    this.$forceUpdate()
    this.infoForm.bank_code = null
    this.infoForm.coin_type = null
    if (this.onCreate[this.infoForm.currency]) {
      this.labelChange = '0'
      this.coinType = this.getBankCode[this.infoForm.currency]
    } else {
      this.labelChange = '1'
      this.bankCodes = this.getBankCode[this.infoForm.currency]
    }
  }

  @Watch('infoForm.currency')
  private watchCurrency () {
    if (this.onCreate[this.infoForm.currency]) {
      this.labelChange = '0'
    } else {
      this.labelChange = '1'
    }
  }

  // 获取银行代号列表
  private async getBankCodes () {
    this.bankCodes = await AppModule.GetBankCodeList()
  }

  // 获取银行账户信息
  private async getBankAccountInfo () {
    try {
      const data: any = {
        merchant_no: this.merchant_no,
        id: this.bankAccountId
      }
      await getBankInfo(data).then((res: any) => {
        this.agentProductInfo = res
        this.infoForm = {
          ...this.infoForm,
          ...this.agentProductInfo
        }
      })
    } catch (e) {}
  }

  // 获取常量里面的USDT所对应的参数
  private async getConstant () {
    await getConstant().then((res: any) => {
      this.onCreate = res.SETTLEMENT_BANK_CARD_FIELD
      this.otherCurrency = this.onCreate.USDT
    })
  }

  // 获取银行代号列表
  private async getEnterprises () {
    await getEnterprise().then((res: any) => {
      this.getBankCode = res.currency_bank
      this.availableCurrency = res.available_currency
    })
  }

  private init () {
    this.currentProductIndex = null
    this.infoForm = {}
  }
  destroy () {
    this.init()
  }
  mounted () {
    if (this.bankAccountId) {
      this.getBankAccountInfo()
      // this.infoForm.status = this.agentProductInfo.status
      // console.log(this.infoForm.status)
    }
  }
  created () {
    this.getConstant()
    this.getEnterprises()
  }
}
